import { Tooltip } from "@mui/material";
import { BusinessIcon, LogoutIcon } from "assets/iconsSVG";
import SellItLogoCircle from "assets/iconsSVG/sellitLogoCircle";
import { converterObjetoParaString } from "hooks/convertObjectToString";
import { useBuscarLeadInterface } from "interfaces";
import React from "react";
import { RootStateOrAny, useSelector } from "react-redux";
import { useCorretoresEmpresaVendas } from "services/api";
import signOut from "services/signOut";
import { AuthState } from "store/ducks/auth/types";
import { MdFace6 } from "react-icons/md";
import { usePlantaoVendas } from "contexts/PlantaoVendasContext";
import SupervisorContent from "./components/SupervisorContent";
import DropdownBox from "./components/dropdownBox";
import FormHorizontalSearch from "./components/formHorizontalSearch";
import * as Styles from "./styles";
import * as IconsSVG from "../../../../assets/iconsSVG";

const HeaderContent = () => {
  const { plantaoVendas, empresaVendas, supervisorProduto } = useSelector<
    RootStateOrAny,
    AuthState
  >((state) => state.user);
  const { plantaoVendas: pdvSelected } = usePlantaoVendas();
  const { data: dataCorretores, isLoading: isLoadingDataCorretores } =
    useCorretoresEmpresaVendas({
      queryKey: `corretores_empresas_header`,
      params: converterObjetoParaString({
        idsEmpresasVendas: empresaVendas?.map((item) => item.id),
      }),
      enabled: true,
    });

  const [modalIsOpen, setModalIsOpen] = React.useState(false);
  const [corretor, setCorretor] = React.useState(null);
  const [paramsBuscarLead, setParamsBuscarLead] =
    React.useState<useBuscarLeadInterface>({
      IdCorretor: "",
      NomeLead: "",
      TelefoneLead: "",
      EmailLead: "",
      IdPdv: "",
    });

  const sendData = (dataFromChild: useBuscarLeadInterface) => {
    setParamsBuscarLead(dataFromChild);
  };

  function exitApp() {
    signOut();
  }
  return (
    <Styles.Section>
      <Styles.Content>
        <Styles.Header>
          <SellItLogoCircle />
          {supervisorProduto ? (
            <SupervisorContent />
          ) : (
            <Styles.HeaderButtons>
              <Styles.RoletaButton
                onClick={() => {
                  window.location.href = "/carometro";
                }}
              >
                <MdFace6 color="#2d5bff" width="30" height="30" />
                <p>Carômetro</p>
              </Styles.RoletaButton>
              <Styles.RoletaButton
                onClick={() => {
                  window.location.href = "/roleta";
                }}
              >
                <IconsSVG.RoletaIcon color="#2d5bff" width="30" height="30" />
                <p>Roleta</p>
              </Styles.RoletaButton>
              <Styles.PDVName>
                <BusinessIcon color="#2d5bff" />
                <p>{plantaoVendas?.nome || "Plantão de Vendas"}</p>
              </Styles.PDVName>
              <Tooltip
                title="Sair do sistema"
                followCursor
                arrow
                placement="top"
              >
                <Styles.ButtonLogoff onClick={() => exitApp()}>
                  <LogoutIcon color="#2d5bff" />
                </Styles.ButtonLogoff>
              </Tooltip>
            </Styles.HeaderButtons>
          )}
        </Styles.Header>
      </Styles.Content>
      <p
        style={{
          fontFamily: "Inter",
          fontStyle: "normal",
          fontSize: "14px",
          marginTop: "19px",
        }}
      >
        Encontrar cliente
      </p>
      <FormHorizontalSearch
        corretoresEmpresaVendas={dataCorretores}
        IdProduto={plantaoVendas?.id}
        isLoadingDataCorretores={isLoadingDataCorretores}
        sendData={sendData}
        setModalIsOpen={() => setModalIsOpen(true)}
        corretorSelected={(val: any) => setCorretor(val)}
        disabled={supervisorProduto && pdvSelected === null}
      />
      <DropdownBox
        onCloseMain={() => setModalIsOpen(false)}
        visitaAgendadaStates={{
          corretorDonoId: paramsBuscarLead?.IdCorretor,
          corretores: dataCorretores,
        }}
        paramsBuscarLead={paramsBuscarLead}
        isOpen={modalIsOpen}
        onClose={() => setModalIsOpen(false)}
        corretor={corretor}
      />
    </Styles.Section>
  );
};

export default HeaderContent;
